import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ApiError } from "../lib/api";
import { Button } from "../components/Button";
import { BrandMark } from "../components/BrandMark";
import { Footer } from "../components/Footer";

export function LoginPage() {
  const { status, mustChangePassword, login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (status === "authed") {
    return <Navigate to={mustChangePassword ? "/change-password" : "/app"} replace />;
  }

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(username.trim(), password, remember);
      navigate("/app");
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Could not sign in.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-full flex-col">
      <div className="flex flex-1 items-center justify-center p-4">
        <div className="w-full max-w-[400px] animate-rise-in">
          <div className="mb-7 flex flex-col items-center gap-3 text-center">
            <BrandMark size={40} />
            <div>
              <h1 className="text-base font-semibold tracking-tight text-zinc-900">Images by BT4Team</h1>
              <p className="mt-1 text-[13px] text-zinc-500">Sign in to manage the library.</p>
            </div>
          </div>

          <form onSubmit={onSubmit} className="glass glass-strong space-y-4 rounded-2xl p-6 shadow-glass-lg">
            <label className="block">
              <span className="mb-1.5 block text-[13px] font-medium text-zinc-700">Username</span>
              <input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
                className="field"
                required
              />
            </label>
            <label className="block">
              <span className="mb-1.5 block text-[13px] font-medium text-zinc-700">Password</span>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                className="field"
                required
              />
            </label>
            <label className="flex items-center gap-2 text-[13px] text-zinc-600">
              <input
                type="checkbox"
                checked={remember}
                onChange={(e) => setRemember(e.target.checked)}
                className="h-3.5 w-3.5 rounded border-zinc-300 text-zinc-900 focus:ring-zinc-900/20"
              />
              Keep me signed in for 30 days
            </label>

            {error && (
              <p className="rounded-lg border border-red-200 bg-red-50/80 px-3 py-2 text-[13px] text-red-700">
                {error}
              </p>
            )}

            <Button type="submit" variant="primary" size="lg" loading={busy} className="w-full">
              Sign in
            </Button>
          </form>

          <p className="mt-5 text-center text-[13px]">
            <Link to="/" className="text-zinc-500 transition-colors hover:text-zinc-900">
              Back to the overview
            </Link>
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
